<template>
  <div class="d-flex flex-column">
    <div class="title mb-6">
      {{$t('Описание')}}
    </div>
    <div class="d-flex flex-column ga-4">
      <div class="d-flex flex-column ga-1">
        <label class="field-label">{{$t('Название страницы')}}</label>
        <v-text-field
            ref="inputRef"
            variant="outlined"
            :placeholder="$t('Например, Elena Beauty')"
            hide-details
            density="compact"
            rounded="lg"
            bg-color="#fff"
            v-model="form.title"
            clearable
            maxlength="255"
        >
          <template v-slot:clear>
            <v-hover>
              <template v-slot:default="{ props }">
                <v-icon :icon="ClearIcon" v-bind="props" @click="form.title = ''"/>
              </template>
            </v-hover>
          </template>
        </v-text-field>
      </div>
      <div class="d-flex flex-column ga-1">
        <label class="field-label">{{$t('Описание')}}</label>
        <v-textarea v-model="form.desc" clearable variant="outlined" maxlength="2000"
                    rounded="lg" no-resize :placeholder="$t('Например, магазин украшений ручной работы')">
          <template v-slot:clear>
            <v-hover>
              <template v-slot:default="{ props }">
                <v-icon :icon="ClearIcon" v-bind="props" @click="form.desc = ''"/>
              </template>
            </v-hover>
          </template>
        </v-textarea>
      </div>
    </div>
    <v-btn variant="flat" color="primary" rounded="lg" @click="saveTextInfo" class="w-100" :disabled="!hasChanges()">
      {{$t('Сохранить')}}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from "vue";
import ClearIcon from "~/assets/icons/clear.vue";
import {useTapStore} from '@/stores/tapStore';
import {useDialogStore} from "@/stores/dialogStore";
import { useChangeTracker } from "@/composables/useChangeTracker"


const tapStore = useTapStore();
const dialogStore = useDialogStore()

const form = ref({
  title: '',
  desc: ''
})

const saveTextInfo = () => {
  tapStore.setTextInfo(form.value.title, form.value.desc)
  dialogStore.close()
  tapStore.currentTapLang.infoChanged = true
}
const { hasChanges, setOriginal } = useChangeTracker(form)

onMounted(() => {
  form.value = {
    title: tapStore.currentTapLang?.name,
    desc: tapStore.currentTapLang?.description
  }
  setOriginal(form)
  dialogStore.setCheckChanges(hasChanges)
})
</script>

<style scoped lang="sass">
.title
  color: #363636
  text-align: center
  font-size: 20px
  font-weight: 600
  line-height: normal
</style>
